import { IUndergroundInfo, ETravelType } from 'shared/types/houseInfo/underground';

import {
  IconMetroMsk16,
  IconMetroSpb16,
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconWalk16,
  IconBus16,
} from '@cian/ui-kit/icons';
import { IIconProps } from '@cian/ui-kit/icons/internal';
import { UndergroundItem } from 'shared/components/TransportAccessibility';
import { FC } from 'react';
import { getValue } from './getValue';

const REGION_METRO_ICON_MAP = new Map<number, FC<IIconProps>>([
  [1, IconMetroMsk16],
  [2, IconMetroSpb16],
  [4612, IconMetroEkb16],
  [4618, IconMetroKzn16],
  [4596, IconMetroNN16],
  [4598, IconMetroNovosib16],
  [4608, IconMetroSam16],
]);

const TRAVEL_TYPE_ICON_MAP = {
  walk: IconWalk16,
  transport: IconBus16,
};

export const renderUndergrounds = (undergrounds: IUndergroundInfo[], regionId: number) =>
  undergrounds.map((item, index) => {
    const travelType = getValue(item.travelType, ETravelType.Walk);
    const travelTypeIcon = TRAVEL_TYPE_ICON_MAP[travelType];
    const travelTime = item.travelTime ? `${item.travelTime} мин.` : /* istanbul ignore next */ undefined;
    const metroIcon = getValue(REGION_METRO_ICON_MAP.get(regionId), IconMetroMsk16);
    const iconColor = getValue(item.lineColor, '');

    return (
      <UndergroundItem
        key={index}
        icon={metroIcon}
        iconColor={iconColor}
        name={item.name}
        travelTypeIcon={travelTypeIcon}
        travelTime={travelTime}
      />
    );
  });
